import { DeliveryProvider } from '../../../../../services/exports/Constants';

export default {
  title: 'Verifică eligibilitatea adresei pentru livrare',
  or: 'sau',
  form: {
    company: {
      label: 'Selectează restaurantul',
    },
    address: {
      label: 'Introduceți adresa',
    },
  },
  result: {
    positive: '{{address}} este eligibilă pentru livrare externă',
    negative: '{{address}} nu este eligibilă pentru livrare externă',
  },
  providers: {
    [DeliveryProvider.FirstDelivery]: 'Uber',
    [DeliveryProvider.UberDrive]: 'Uber',
    [DeliveryProvider.WoltDrive]: 'Wolt',
  },
  buttons: {
    check: 'Verifică',
  },
  toasts: {
    error: 'Verificarea eligibilității adresei a eșuat',
  },
};
